var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('div',{staticClass:"container body-content",attrs:{"id":"app"}},[_c('app-header',{attrs:{"title":_vm.header}}),_c('router-view')],1),_c('app-footer',{attrs:{"title":_vm.footer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }